import React, { useState } from "react";
import ReactInputMask from "react-input-mask";
import {
  Button,
  Col,
  Input,
  InputGroup,
  Row,
  InputGroupText,
  FormGroup,
  Label,
} from "reactstrap";
import Calendar from "assets/icon/calendar-pms.svg";
import addIcon from "../../../../assets/icon/add.svg";
import DatePicker from "react-datepicker";
import moment from "moment";
import Checkbox from "components/common/Fields/Checkbox";
import closeIcon from "../../../../assets/icon/close.svg";
import addBlackIcon from "../../../../assets/icon/add-black-icon.svg";
import calenderBlackIcon from "../../../../assets/inventory/calender-black-icon.svg";

import { Field, Formik } from "formik";
import Select from "react-select";

const AddNewPatientDetails = ({
  data,
  setData,
  focusedInput,
  setFocusedInput,
}) => {
  const [dobDate, setDobDate] = useState("");
  const [hippaStartDate, setHippaStartDate] = useState(null);
  const [hippaFocusInput, setHippaFocusInput] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [isDobHover, setIsDobHover] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([
    {
      male: "",
      female: "",
      city: "",
      state: "",
      country: "",
      language: "",
      translations: "",
      childsafety: "",
      hippa: "",
      pet: "",
      data: "",
    },
  ]);

  const [allergies, setAllergies] = useState([{ id: 1, data: "Penicillin" },{ id: 2, data: "Sulfa" }]);
  const handleSubmit = () => {
    if (selectedOptions.data) {
      setAllergies((prev) => [
        ...prev,
        { id: Date.now(), data: selectedOptions.data },
      ]);
    }
    setSelectedOptions((prev) => ({ ...prev, data: "" }));
  };

  const handleDelete = (id) => {
    setAllergies((prev) => prev.filter((item) => item.id !== id));
  };

  const handleChangeOption = (e) => {
    const { name, value } = e.target;
    setSelectedOptions((prev) => ({ ...prev, [name]: value }));
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setData((prevData) => ({ ...prevData, [name]: value }));
  // };

  const handleOptionsChange = (selectedOption, actionMeta) => {
    const { name } = actionMeta; // gets the name from Select
    const value = selectedOption?.value || "";
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    if (name === "primaryPhone" || name === "secondaryPhone") {
      const digits = value.replace(/\D/g, "");
      if (digits.length <= 3) {
        formattedValue = digits;
      } else if (digits.length <= 6) {
        formattedValue = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else {
        formattedValue = `(${digits.slice(0, 3)}) ${digits.slice(
          3,
          6
        )}-${digits.slice(6, 10)}`;
      }
    } else {
      formattedValue = value.charAt(0).toUpperCase() + value.slice(1);
    }
    setData({ ...data, [name]: formattedValue });
  };

  let hasDatePopupOpen = false;

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleStartDate = (startDate) => {
    if (startDate !== null) {
      const date = moment(startDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setDobDate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setDobDate(null);
      // SearchTerms.startDate=null
    }
  };

  const handleFocus = (inputName) => {
    setFocusedInput(inputName);
  };

  const handleBlur = () => {
    setFocusedInput("");
  };

  const handleStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && dobDate !== null) {
      setDobDate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  let hasHippaDatePopupOpen = false;

  const handleHippaMouseLeave = () => {
    hasHippaDatePopupOpen = false;
  };

  const handleHippaStartDate = (hippaStartDate) => {
    if (hippaStartDate !== null) {
      const date = moment(hippaStartDate, "MM/DD/YYYY", true);
      if (date.isValid()) {
        setHippaStartDate(date.toDate());
        // SearchTerms.startDate=startDate
      }
    } else {
      setHippaStartDate(null);
      // SearchTerms.startDate=null
    }
  };

  const handleHippaFocus = (inputName) => {
    setHippaFocusInput(inputName);
  };

  const handleHippaBlur = () => {
    setHippaFocusInput("");
  };

  const handleHippaStartDateRaw = (e) => {
    var val = e.target.value;
    if (val == "__/__/____" && hippaStartDate !== null) {
      setHippaStartDate(null);
      // setError(false);
      //SearchTerms.startDate = null;
    }
    if (val !== undefined && val.length == 10 && val.indexOf("_") == -1) {
      handleHippaStartDate(e.target.value);
      //SearchTerms.startDate = val;
    }
  };

  const handleHippaDateClick = (id) => {
    if (hasHippaDatePopupOpen) {
      hasHippaDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasHippaDatePopupOpen = true;
    }
  };

  const GenderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "unknown", label: "Unknown" },
  ];

  const StateOptions = [
    {
      value: "newjersy",
      label: "Jercy City",
    },
    {
      value: "illinois",
      label: "Illinois",
    },
    {
      value: "newyork",
      label: "New York",
    },
  ];

  const CityOptions = [
    {
      value: "chicago",
      label: "Chicago",
    },
    {
      value: "springfield",
      label: "Spring Field",
    },
    {
      value: "rockford",
      label: "Rock Ford",
    },
  ];

  const CountryOptions = [
    {
      value: "usa",
      label: "USA",
    },
    {
      value: "india",
      label: "India",
    },
    {
      value: "canada",
      label: "Canada",
    },
  ];
  const prefixOption = [
    {
      value: "Dr",
      label: "Dr",
    },
    {
      value: "Med Dr",
      label: "Med Dr",
    },
  ];

  const suffixOption = [
    {
      value: "MD",
      label: "MD",
    },
    {
      value: "PhD",
      label: "PhD",
    },
  ];

  return (
    <>
      <div className="invOrderDetails">
        <Formik>
          <FormGroup>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">
                  <span className="text-danger me-1">*</span>Last Name
                </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter First Name"
                      name="firstname"
                      value=""
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">
                  <span className="text-danger me-1">*</span> First Name
                </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Last Name"
                      name="lastname"
                      value=""
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading"> Middle Initial/Name</div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Middle Name"
                      name="middlename"
                      value={data.middlename}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="required-date add-patient-pl">
                <FormGroup className="controls textarea_info search-flex mb-0">
                  <div className="add-patient-heading">
                    <span className="text-danger me-1">*</span>Date of Birth
                  </div>
                  <InputGroup onMouseLeave={handleMouseLeave}>
                    <DatePicker
                      id="dobDate"
                      name="dobDate"
                      selected={dobDate}
                      onChange={(dobDate) => handleStartDate(dobDate)}
                      onFocus={() => handleFocus("dobDate")}
                      onBlur={handleBlur}
                      isClearable
                      onChangeRaw={handleStartDateRaw}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Select Date"
                      autoComplete="off"
                      customInput={
                        <ReactInputMask mask="99/99/9999" value={dobDate} />
                      }
                    />
                    <InputGroupText
                      onClick={() => handleDateClick("dobDate")}
                      onMouseEnter={() => setIsDobHover(!isDobHover)}
                      onMouseLeave={() => setIsDobHover(!isDobHover)}
                    >
                      <img
                        src={isDobHover ? Calendar : calenderBlackIcon}
                        alt=""
                        className="cursor-pointer"
                      />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr ps-1">
                <div className="add-patient-heading">Name Prefix</div>

                <Select
                  // isMulti
                  className="dropdown-options"
                  name="prefix"
                  options={prefixOption}
                  placeholder="Select"
                  onChange={(selectedOptions) => {
                    setData((prev) => ({
                      ...prev,
                      prefix: selectedOptions || [],
                    }));
                  }}
                />
              </Col>
              <Col md="6" className="add-patient-pr ps-1">
                <div className="add-patient-heading">Name Suffix</div>

                <Select
                  className="dropdown-options"
                  name="suffix"
                  value={prefixOption.find(
                    (option) => option.value === data.suffix
                  )}
                  options={suffixOption}
                  placeholder="Select"
                  onChange={handleOptionsChange}
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr ps-1">
                <div className="add-patient-heading">
                  <span className="text-danger me-1">*</span>Sex
                </div>
                {/* <InputGroup className="p-1">
                  <Field
                    as="select"
                    name="gender"
                    id="option"
                    className="order-detail-input"
                    value={data.gender}
                    onChange={handleChange}
                  >
                    <option value="male" label="Male" />
                    <option value="female" label="Female" />
                  </Field>
                </InputGroup> */}
                <Select
                  className="dropdown-options"
                  name="gender"
                  value={GenderOptions.find(
                    (option) => option.value === data.gender
                  )}
                  options={GenderOptions}
                  placeholder="Select"
                  onChange={handleOptionsChange}
                />
              </Col>
            </Row>
            <div className="section-devider-border mt-3 mb-3"></div>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Address Line 1 </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Address 1"
                      name="streetaddres1"
                      value={data.streetaddres1}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Address Line 2</div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter Address 2"
                      name="streetaddres2"
                      value={data.streetaddres2}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">City </div>
                <Select
                  className="dropdown-options"
                  options={CityOptions}
                  placeholder="Select City"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">State/Province</div>
                <Select
                  className="dropdown-options"
                  options={StateOptions}
                  placeholder="Select State"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Zip/Postal Code </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "usa", label: "USA" },
                    { value: "india", label: "Inida" },
                    { value: "canada", label: "Canada" },
                  ]}
                  placeholder="Select Language"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">
                  {" "}
                  <span className="text-danger me-1">*</span>Primary Phone
                </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter"
                      name="primaryPhone"
                      value={data.primaryPhone}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Secondary Phone </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter"
                      name="secondaryPhone"
                      value=""
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">
                  {" "}
                  <span className="text-danger me-1">*</span>Email
                </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter"
                      name="email"
                      value=""
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <div className="section-devider-border mt-3 mb-3"></div>

            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Automatic Refills</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Yes", label: "Yes" },
                    { value: "No", label: "No" },
                  ]}
                  placeholder="Select"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Primary Prescriber</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Smith", label: "Smith" },
                    { value: "John", label: "Doe" },
                  ]}
                  placeholder="Select"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Preferred Language</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "english", label: "English" },
                    { value: "hindi", label: "Hindi" },
                    { value: "french", label: "French" },
                  ]}
                  placeholder="Select"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Requires Translation </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Child Safety Caps</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select "
                />
              </Col>
              <Col md="6" className="required-date add-patient-pl">
                <FormGroup className="controls textarea_info search-flex mb-0">
                  <div className="add-patient-heading">
                    HIPAA Acknowledgement Date
                  </div>
                  <InputGroup onMouseLeave={handleHippaMouseLeave}>
                    <DatePicker
                      id="hippaStartDate"
                      name="hippaStartDate"
                      selected={hippaStartDate}
                      onChange={(hippaStartDate) =>
                        handleHippaStartDate(hippaStartDate)
                      }
                      onFocus={() => handleHippaFocus("hippaStartDate")}
                      onBlur={handleHippaBlur}
                      isClearable
                      onChangeRaw={handleHippaStartDateRaw}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Select"
                      autoComplete="off"
                      customInput={
                        <ReactInputMask
                          mask="99/99/9999"
                          value={hippaStartDate}
                        />
                      }
                    />
                    <InputGroupText
                      onClick={() => handleHippaDateClick("hippaStartDate")}
                    >
                      <img
                        src={hippaFocusInput ? Calendar : calenderBlackIcon}
                        alt=""
                        className="cursor-pointer"
                      />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">HIPAA</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select"
                />
              </Col>
              <Col md="6"></Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="add-patient-heading mb">Notes</div>
                <div>
                  <FormGroup className="mb-0">
                    <Input
                      style={{ border: "1px soild" }}
                      className="textlength"
                      type="textarea"
                      placeholder="Enter Notes"
                    />
                  </FormGroup>
                </div>
              </Col>
            </Row>
            <div
              className="section-devider-border mt-3 mb-3"
              style={{ marginTop: "12px" }}
            ></div>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">County</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Travis", label: "Travis" },
                    { value: "Baldwin", label: "Baldwin" },
                    { value: "Blount", label: "Blount" },
                  ]}
                  placeholder="Select"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Country </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select"
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">SSN </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter"
                      name="ssn"
                      value=""
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Marital Status</div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter"
                      name="maritalStatus"
                      value=""
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Race</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "Travis", label: "Travis" },
                    { value: "Baldwin", label: "Baldwin" },
                    { value: "Blount", label: "Blount" },
                  ]}
                  placeholder="Select County"
                />
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Ethnicity</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select "
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="add-patient-pr">
                <div className="add-patient-heading">Mother’s Maiden Name </div>
                <div>
                  <InputGroup>
                    <Input
                      placeholder="Enter"
                      name="maidenName"
                      value={data.maidenName}
                      onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Deceased </div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "yes", label: "Yes" },
                    { value: "no", label: "No" },
                  ]}
                  placeholder="Select "
                />
              </Col>
            </Row>
            <Row>
              <Col md="6" className="required-date add-patient-pl">
                <FormGroup className="controls textarea_info search-flex mb-0">
                  <div className="add-patient-heading">Deceased Date</div>
                  <InputGroup onMouseLeave={handleHippaMouseLeave}>
                    <DatePicker
                      id="hippaStartDate"
                      name="hippaStartDate"
                      selected={hippaStartDate}
                      onChange={(hippaStartDate) =>
                        handleHippaStartDate(hippaStartDate)
                      }
                      onFocus={() => handleHippaFocus("hippaStartDate")}
                      onBlur={handleHippaBlur}
                      isClearable
                      onChangeRaw={handleHippaStartDateRaw}
                      dateFormat="MM/dd/yyyy"
                      placeholderText="Select"
                      autoComplete="off"
                      customInput={
                        <ReactInputMask
                          mask="99/99/9999"
                          value={hippaStartDate}
                        />
                      }
                    />
                    <InputGroupText
                      onClick={() => handleHippaDateClick("hippaStartDate")}
                    >
                      <img
                        src={hippaFocusInput ? Calendar : calenderBlackIcon}
                        alt=""
                        className="cursor-pointer"
                      />
                    </InputGroupText>
                  </InputGroup>
                </FormGroup>
              </Col>
              <Col md="6" className="add-patient-pl">
                <div className="add-patient-heading">Residence Code</div>
                <Select
                  className="dropdown-options"
                  options={[
                    { value: "01-home", label: "01-Home" },
                    { value: "02-home", label: "02-Home" },
                  ]}
                  placeholder="Select"
                />
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <div className="add-patient-text">Allergies </div>
                <div className="veterinary-patient p-2 m-0">
                  <InputGroup className="bg-white">
                    <Input
                      placeholder="Add New Allergy"
                      name="data"
                      value={selectedOptions.data}
                      onChange={handleChangeOption}
                    />
                    {selectedOptions.data ? (
                      <img
                        src={addIcon}
                        alt=""
                        className="m-1 cursor-pointer"
                        onClick={handleSubmit}
                      />
                    ) : (
                      <img
                        src={addBlackIcon}
                        alt=""
                        className="m-1 cursor-pointer"
                        onClick={handleSubmit}
                      />
                    )}
                  </InputGroup>

                  <div className="d-flex justify-content-start align-items-center direction-row gap-2">
                    {allergies.map((name) => (
                      <div
                        className={name.data ? "allergies-add-data" : ""}
                        key={name.id}
                      >
                        <div onClick={() => handleDelete(name.id)}>
                          <span>{name.data}</span>
                          <img
                            src={name.data ? closeIcon : ""}
                            alt=""
                            className="cursor-pointer"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
            <div className="divider-line"></div>
            <div className="add-patient-text d-flex justify-content-between align-items-center me-2">
              <div style={{ marginTop: "16px" }}>Veterinary Patient</div>
              <Checkbox activeCheck={true} />
            </div>
            <Row className="veterinary-patient p-2 m-0 gap-2">
              <Col className="p-0" style={{ marginRight: "6px" }}>
                <div className="add-patient-species mt-0 ms-0">Species </div>
                <Select
                  options={[
                    { value: "dog", label: "Dog" },
                    { value: "cat", label: "Cat" },
                    { value: "horse", label: "Horse" },
                  ]}
                  placeholder="Select Species"
                />
              </Col>
              <Col className="p-0" style={{ marginLeft: "6px" }}>
                <div className="add-patient-species mt-0 ms-0">Owners Name</div>
                <div>
                  <InputGroup className="p-0">
                    <Input
                      placeholder="Enter Name"
                      // name="middlename"
                      // value={data.middlename}
                      // onChange={handleChange}
                    />
                  </InputGroup>
                </div>
              </Col>
            </Row>
          </FormGroup>
        </Formik>
      </div>
    </>
  );
};

export default AddNewPatientDetails;
